import { useEffect, useState } from 'react'

const useFiltersClose = (shouldCloseFilters: boolean | undefined) => {
  const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined)

  // to close all filters when scrolling down while sticky header is there
  useEffect(() => {
    if (shouldCloseFilters) {
      setIsOpen(false)
    } else {
      setIsOpen(undefined)
    }
  }, [shouldCloseFilters])

  return isOpen
}

export default useFiltersClose
